module.exports = __webpack_public_path__ + "img/userBaner.d29b3582.jpg";